import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-cards',
  templateUrl: './ui-cards.component.html',
  styleUrls: ['./ui-cards.component.css']
})
export class UiCardsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
